import { render, staticRenderFns } from "./PfCard.vue?vue&type=template&id=52e17324"
import script from "./PfCard.vue?vue&type=script&lang=js"
export * from "./PfCard.vue?vue&type=script&lang=js"
import style0 from "./PfCard.vue?vue&type=style&index=0&id=52e17324&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports